import { BooleanProperty, ObjectProperty, } from '@baeso-ui/baeso-observable';
import { FormControl, } from '../BaseVM';
export class StructuredTextInputVM extends FormControl {
    constructor(init) {
        super(init);
        this.text = (init === null || init === void 0 ? void 0 : init.text) ? init.text : new ObjectProperty('text');
        this.editable = (init === null || init === void 0 ? void 0 : init.editable) ? init.editable : new BooleanProperty('editable', true);
    }
}
